/* Defines the airport entity */


//what was the deal you only need this if you are going to try to do something but can't remember what'
export interface IAirport {
    locId: string;
    region: string;
    regionName: string;
    name: string;
    city: string;
    state: string;
    facilityClass: string;
    atctFacility: number;
    facilityLevel: string;

    //Hub fields
    hubSize: string;
    hubLocId: string;
    reliever: number;
    relieverId: string;
    centerAreaId: string;
    approachControlId: string;
    siteNumber: string;
    naspNumber: number;
    latitude: string;
    longitude: string;

    //will probably need something later for comments/notes 
    comments: string;
    primaryRadar: number;
    noAddFacility: number;
    opsFlag: string;
    regionalInput: number;
    regionalInputStartYear: string;
    regionalInputEndYear: string;

    regName: string;
    stateName: string;
    facLevelName: string;
    hubSizeName: string;
    facClassName: string;
    OpsFlagName: string;
}

export interface IOperation {
    tableName: string;
    displayName: string;
}


export class OperationsListRequest{
    tableName: string;
    locId: string;
    scenarioId: number;
    isAdmin: number;
}

export interface IOperationListColumnResponse{
    tableDisplay: string;
    fieldName: string;
    displayName: string;
    graphName: string;
    calculated: number;
    styleShow: number;
    graphR: number;
    isAAT:number;
}

export interface IEditRowField{
    value: string;
    fieldName: string;
    displayName: string;
    readOnly: boolean;
    display: boolean;
}

export class ReforecastRequest{
    fieldName: string;
    tableName: string;
    locId: string;
    scenarioId: number;
    minYear: number;
}

export interface IReforecastResponse{
    aYear: number;
    value: number;
    scenario: number;
    lastYearsValue: number;
    originalValue: number;
    growth: number;
    originalGrowth: number;
}

export class RegionalReviewRequest{
    startYear: number;
    scenario: number;
}




/** WEBPACK FOOTER **
 ** ./app/airports/airport-interfaces.ts
 **/